var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['app', ("app-" + (_vm.routerName.toLowerCase()))],attrs:{"id":"app"}},[_c('Header',{attrs:{"bgColor":"#333"}},[_c('Nav',{attrs:{"bgColor":"#333","routerName":_vm.routerName}})],1),_c('div',{staticClass:"layout",style:({
        height: _vm.$route.name === 'Main' ? ("" + _vm.appLayoutHeight) : 'auto'
    })},[_c('router-view')],1),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }